export default {
    ifYouLike: 'If you like',
    youMayLike: 'you may like...',
    title: 'Models You May Like',
    moreModels: 'More Models You May Like...',
    noRecommendations: 'No recommended models are currently online for',
    noSelection: 'Please select model(s) above to view models you may like.',
    noSelectionOrPool:
        'To see recommendations, please search for a model or choose a friend to view models you may like.',
    searchInstructions:
        'Enter the username of a model that you like and we will automatically suggest other online models that you may like',
    detailedInstructions: 'You may select an individual or multiple models',
    detailedDrawerInstructions:
        'Every time you view recommendations for a model, we add that model to history so you may easily view recommendations in the future',
    resultMessage: 'Based on your selection of ',
    resultMessageEnd: ', you may also like',
    guestWarningPartOne:
        'You are currently logged in as a Guest and you have attempted to access a feature that is reserved for registered members of our website. We try to offer as much functionality as possible to guest accounts, but for certain personal features and preferences we do require that you login or register free.',
    guestWarningPartTwo:
        'Registration is absolutely free, you will never be charged in any way. Simply go to our free registration page, enter your e-mail address and select your username and password. We will instantly create your own personal account and you can use it forever, completely free. We will never spam you or share your e-mail address with anyone.',
    guestWarningPartThree: 'We look forward to having you as a member. ',
    guestWarningPartFour: 'Click here to make your free account',
    guestWarningPartFive: 'If you are already a member, please click here to ',
    guestWarningPartSix: 'please click here to login',
    guestWarningPartSeven: '. Thanks!',
    explainPool:
        'No models selected. Every time you view recommendations for a model, we add that model to history so you may easily view recommendations in the future',
}
